import {ENDPOINT_PRESCORE_V2} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader} from 'common/utils';

const getJobMetadata = () =>
  fetch(`${ENDPOINT_PRESCORE_V2}/status/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });


const scoreApplications = (fundingOpportunityId) => {
  return fetch(
    `${ENDPOINT_PRESCORE_V2}/score/${fundingOpportunityId}`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
    }
  );    
};

export default {
  getJobMetadata,
  scoreApplications,
};
